import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const symbols = ["🌂", "🌂", "☔️"];

export default function UmbrellaRainAnimation({transparent}) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % 3);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const getSymbols = () => {
    const newSymbols = [...symbols];
    newSymbols.splice(2, 1);
    newSymbols.splice(index, 0, "☔️");
    return newSymbols;
  };

  const animatedSymbols = getSymbols();

  return (
    <div style={outerContainer}>
      <div style={innerContainer}>
        <div style={animationRow}>
          {animatedSymbols.map((symbol, i) => (
            <motion.div
              key={i}
              animate={
                symbol === "☔️"
                  ? { y: [0, -10, 0] }
                  : { y: 0 }
              }
              transition={
                symbol === "☔️"
                  ? { duration: 1, ease: "easeInOut" }
                  : {}
              }
              style={symbolStyle}
            >
              {symbol}
            </motion.div>
          ))}
        </div>
        <p style={textStyle}>Loading data...</p>
        <p style={{ fontFamily: 'comicregular', fontSize: 'large',color:'gray',opacity:transparent,transition:'opacity 1s'}}>It may take about a minute to be loaded, Please wait...</p>
      </div>
    </div>
  );
}

// 样式对象
const outerContainer = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "150px",
  flexDirection: "column",
  marginTop:'45px'
};

const innerContainer = {
  textAlign: "center"
};

const animationRow = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "20px",
  marginBottom: "10px",
  fontSize: "48px",
  fontWeight: "bold"
};

const symbolStyle = {
  display: "inline-block"
};

const textStyle = {
  fontFamily: "comicbold",
  fontSize: "x-large",
  color: "gray"
};
